import { Provider } from '@angular/core';

export class LocalStorageService {
  get(_key: string): any {
    return null;
  }
}

export function LocalStorageServiceFactory(i: any) {
  return i.get('localStorageService');
}

export const LocalStorageServiceProvider: Provider = {
  provide: LocalStorageService,
  useFactory: LocalStorageServiceFactory,
  deps: ['$injector'],
};
